
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { CommentSortOption } from '@/services/comments/types';

// Make SortOption exactly match CommentSortOption to avoid type conflicts
export type SortOption = 'newest' | 'oldest' | 'top' | 'votes';

interface CommentSortControlsProps {
  sortBy: SortOption;
  onSortChange: (value: SortOption) => void;
  pageSize?: number;
  onPageSizeChange?: (value: number) => void;
}

const CommentSortControls: React.FC<CommentSortControlsProps> = ({
  sortBy,
  onSortChange,
  pageSize,
  onPageSizeChange
}) => {
  return (
    <div className="flex items-center gap-2">
      <Select value={sortBy} onValueChange={onSortChange}>
        <SelectTrigger className="w-[140px]">
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="newest">Newest first</SelectItem>
          <SelectItem value="oldest">Oldest first</SelectItem>
          <SelectItem value="top">Top votes</SelectItem>
          <SelectItem value="votes">Most votes</SelectItem>
        </SelectContent>
      </Select>

      {pageSize && onPageSizeChange && (
        <Select value={pageSize.toString()} onValueChange={(value) => onPageSizeChange(parseInt(value))}>
          <SelectTrigger className="w-[140px]">
            <SelectValue placeholder="Comments per page" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="5">5 per page</SelectItem>
            <SelectItem value="10">10 per page</SelectItem>
            <SelectItem value="20">20 per page</SelectItem>
            <SelectItem value="50">50 per page</SelectItem>
          </SelectContent>
        </Select>
      )}
    </div>
  );
};

export default CommentSortControls;
